import {
  CButtonClassname,
  EButtonColor,
  ESectionAlign,
  ESectionColor,
  Section,
  SectionSubtitle,
  SectionTitle,
} from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router';
import { getWelcomeLink } from '../../base/utils';
import * as Actions from '../firebaseActions';

export interface IProps {
  onPageVisited: (pathname: string) => void;
}

export const NotFoundPage: React.FC<IProps> = ({ onPageVisited }) => {
  const location = useLocation();
  const { t } = useTranslation();
  React.useEffect(() => {
    onPageVisited(location.pathname);
  }, [location.pathname, onPageVisited]);
  const welcomeLink = getWelcomeLink();
  return (
    <Section color={ESectionColor.orange} align={ESectionAlign.center}>
      <SectionTitle>{t('common.common:Errors.Titles.PageNotFound')}</SectionTitle>
      <SectionSubtitle>{t('common.common:Errors.PageNotFound')}</SectionSubtitle>
      <Link className={`${CButtonClassname} ${EButtonColor.white}`} to={welcomeLink}>
        {t('common.common:BackToMain')}
      </Link>
    </Section>
  );
};
export const mapDispatchToProps = {
  onPageVisited: Actions.firebase404VisitedAction,
};

export default connect(null, mapDispatchToProps)(NotFoundPage);
